import { z } from "zod"
import { LegacyCompatibleDiscountSchema } from "./discount"
import {
  EvaluatedServiceBikePartSchema,
  ManualServiceActionSchema,
  PartGrade,
  ServiceBikeGearSystem,
  ServiceBikeType,
} from "./index"

export const GenerateServiceProposalPreviewSchema = z.object({
  feeIds: z.array(z.string().uuid()),
  originalWashId: z.string().uuid().optional(),
  washLaborPriceDiscount: LegacyCompatibleDiscountSchema.nullable().optional(),
  customerIsClubMember: z.boolean(),
  storeId: z.string().uuid(),
  bikeType: z.nativeEnum(ServiceBikeType),
  bikeIsElectric: z.boolean().nullable(),
  bikeGearSystem: z.nativeEnum(ServiceBikeGearSystem).nullable().default(null),
  // The reception's preview sends components it never graded.
  evaluatedParts: z.array(
    EvaluatedServiceBikePartSchema.extend({
      grade: z.nativeEnum(PartGrade).nullable().default(null),
    }),
  ),
  manualServiceActions: z.array(ManualServiceActionSchema),
  packageDiscounts: z
    .record(z.string().uuid(), LegacyCompatibleDiscountSchema.nullable())
    .optional(),
  selectedPackageIds: z.array(z.string().uuid()).optional(),
  priceListId: z.string().uuid().optional(),
  /** The job's leasing company labels, which decide the packages it may get. */
  leasingCompanyIds: z.array(z.string().uuid()).default([]),
  extraPackagePartActions: z
    .array(
      z.object({
        packageId: z.string().uuid(),
        partId: z.string().uuid(),
      }),
    )
    .optional(),
})
export type GenerateServiceProposalPreview = z.infer<
  typeof GenerateServiceProposalPreviewSchema
>
